import Component from '@glimmer/component';

import { t } from 'ember-intl';

import FileUploader from 'umg-ember-backend/components/ui/file-uploader';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordDetailFormsAssetUploadComponent extends Component {
  // Functions
  setAssetTitle = (file) => {
    if (!this.args.asset.headline) {
      this.args.asset.headline = file.name;
    }
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      {{#if @asset.tmpAssetName}}
        <h3 class={{bem 'headline'}}>
          {{#if @asset.isSaving}}
            {{t 'record_detail.forms.asset.upload.converting'}}
          {{else}}
            {{t 'record_detail.forms.asset.upload.success'}}
          {{/if}}
        </h3>
      {{else}}
        <FileUploader
          @isMultiple={{false}}
          @onUploadStart={{this.setAssetTitle}}
          @onSuccess={{@onUploadSuccess}}
        />
      {{/if}}
    </div>
  </template>
}
